import { render, staticRenderFns } from "./ConceptsContent.vue?vue&type=template&id=50bf00ec"
import script from "./ConceptsContent.vue?vue&type=script&lang=js"
export * from "./ConceptsContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports